import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolder1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"folder-1"} maskId="square-filled-radius-0-stroke-1-IconFolder1"><path d="M10.2676 3H2V20H22V6H12.2676L10.2676 3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFolder1;
